import { Node, Path } from 'slate';

export type GetTextFromNode = (
  node: Node,
  range?: { from: Path; to: Path },
) => string | undefined;

export default function getTextFromNode(
  node: Node,
  range?: { from: Path; to: Path },
): string | undefined {
  const result = Array.from(Node.texts(node, range));

  return result?.map(([leaf]) => leaf.text)?.join('');
}
